export default __webpack_public_path__ + "static/media/beach.93644760.jpg";